import React from 'react'
import MosaicInput from './MosaicInput'
import PropTypes from 'prop-types'

function TwitterMetadata ({ state, onChange }) {
  return (
    <div>
      <MosaicInput
        inputTitle='Brand Handle'
        id='meta-brand-handle'
        className='form-control'
        placeholder='@bluerobot_'
        value={state.twitterSite}
        onChange={onChange('twitterSite')}
      />
      <MosaicInput
        inputTitle='Title'
        id='meta-title'
        className='form-control'
        value={state.twitterTitle}
        onChange={onChange('twitterTitle')}
      />
      <MosaicInput
        inputTitle='Description'
        id='meta-description'
        className='form-control'
        value={state.twitterDescription}
        onChange={onChange('twitterDescription')}
      />
      <MosaicInput
        inputTitle='Preview Image URL'
        id='meta-image-url'
        className='form-control'
        value={state.twitterSiteImageUrl}
        onChange={onChange('twitterSiteImageUrl')}
      />
    </div>
  )
}

TwitterMetadata.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default TwitterMetadata



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/components/TwitterMetadata.js